import type { ReactNode } from "react";

import classes from "./create.module.css";

interface CreateFrameProps {
  composer: ReactNode;
  results: ReactNode;
}

/**
 * The prototype's Create page (`createFrame`): "Create" on top, then the composer card at the left
 * and the mode's recent results at the right (spec ui-perf/pro-studio-redesign, PR c1). The left
 * nav chooses the mode: the prototype's row of modes over the page is gone (spec
 * ui-perf/ui-switch-classic-simple-pro, PR e8).
 */
export function CreateFrame({ composer, results }: CreateFrameProps) {
  return (
    <div className={classes.page}>
      <div className={classes.top}>
        <h1 className={classes.title}>Create</h1>
      </div>
      <div className={classes.create}>
        <div className={classes.composer}>{composer}</div>
        <section aria-label="Results">{results}</section>
      </div>
    </div>
  );
}
